module.exports = __webpack_public_path__ + "static/media/1003019.0a6cda72.jpg";